import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import tippy from 'tippy.js';
import { tracked } from '@glimmer/tracking';

export default class OrganismsListItemDropdownComponent extends Component {
  @service router;
  @service store;

  tippyInstance;
  @tracked isOpen = false;

  constructor() {
    super(...arguments);
  }

  @action
  createTippy(element) {
    let tigger = element.querySelector('.list-title-dropdown');
    let dropdown = element.querySelector('.tippy-dropdown');
    let self = this;
    this.tippyInstance = tippy(tigger, {
      content: dropdown,
      arrow: false,
      trigger: 'click',
      placement: 'right-start',
      interactive: true,
      animation: 'shift-away',
      offset: [-24, 4],
      onShow() {
        self.isOpen = true;
      },
      onHide() {
        self.isOpen = false;
      },
    });
  }

  @action
  closeMenu() {
    this.tippyInstance.hide();
  }

  @action
  navigateToWorkstreamArchives() {
    const workstream = this.store.peekRecord('workstream', this.args.parentId);
    this.closeMenu();
    this.router.transitionTo(
      'backlog.initiatives.initiative.workstreams.workstream.archive',
      workstream.get('initiative.id'),
      workstream.id,
    );
  }

  @action
  showArchive(type) {
    let base_path = '';
    let path = '';

    if (this.args.parentType === 'workstream')
      return this.navigateToWorkstreamArchives();
    if (this.args.parentType === 'initiative')
      base_path = 'initiatives.initiative.planning.archive';
    if (this.args.parentType === 'team')
      base_path = 'operations.teams.team.check-in.archive';
    switch (type) {
      case 'll':
        path = 'lessons-learned';
        break;
      case 'tfo':
        path = 'to-figure-outs';
        break;
      case 'uncertainty':
        path = 'uncertainties';
        break;
      case 'wfa':
        path = 'waiting-for-answers';
        break;

      default:
        path = 'questions';
    }
    this.closeMenu();
    this.router.transitionTo(`${base_path}.${path}`, this.args.parentId);
  }

  @action
  deleteParent() {
    const parentItem = this.store.peekRecord(
      this.args.parentType,
      this.args.parentId,
    );
    parentItem.destroyRecord();
  }

  @action
  editParentTitle() {
    this?.args?.editParentTitle?.();
    this.closeMenu();
  }
}
